import "./App.css";

import React, { Component } from "react";
import "./App.css";
import AppRouter from "./AppRouter";

function App() {
  return (
    <div className="App">
      <AppRouter />
    </div>
  );
}

export default App;
